import React from "react";
import PropTypes from "prop-types";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const TitleSkeleton = ({ width = 280 }) => (
  <div className="row mb-1">
    <div className="col-md-6 col-lg-4 mb-2">
      <div className="d-flex align-items-center">
        <Skeleton width={16} height={15} />
        <div className="ms-2">
          <Skeleton width={width} height={15} />
        </div>
      </div>
    </div>
  </div>
);

TitleSkeleton.propTypes = {
  width: PropTypes.any
};

const ItemSkeleton = ({ count }) => (
  <div className="row mb-1">
    {Array.from({ length: count }).map((_, index) => (
      <div key={index} className="col-md-6 col-lg-4 mb-2">
        <div className="d-flex align-items-center">
          <Skeleton width={14} height={14} />
          <div className="ms-2">
            <Skeleton width={230} height={12} />
          </div>
        </div>
      </div>
    ))}
  </div>
);

ItemSkeleton.propTypes = {
  count: PropTypes.number.isRequired
};

const Divider = () => (
  <div className="row">
    <div className="col-12 mb-2">
      <Skeleton width="100%" height={1} />
    </div>
  </div>
);

const EditUserRoleSkeleton = () => {
  return (
    <div className="p-3">
      <TitleSkeleton />
      <ItemSkeleton count={4} />
      <Divider />

      <TitleSkeleton />
      <ItemSkeleton count={3} />
      <Divider />

      <TitleSkeleton />
      <ItemSkeleton count={6} />
    </div>
  );
};

export default EditUserRoleSkeleton;
